import { useEffect } from "react";

interface JsonLdProps {
  id: string;
  schema: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Injects a Schema.org JSON-LD <script> tag into <head>.
 * Cleans up when the component unmounts.
 */
export default function JsonLd({ id, schema }: JsonLdProps) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [id, schema]);

  return null;
}